
let _ = require('../_.js');
let $ = jQuery;


let current_notification = null;
let current_notification_handler_class = null;
let current_notification_subscription = null;

// Only show each notification once per session.  This prevents the force flash alerts from showing more than once.
let shown_notification_ids_cache = [];

let last_flash_message = null;
let last_flash_message_time = null;

_.Lib_Notifications = class Lib_Notifications {

    // This maps notification codes to notification classes.
    // Todo: make it so the individual notification classes register their mappings via a _register_notification_handler
    static _map_notification_to_handler(notification) {

        // let notification = await App_Models_Notification.get(new_notification.id);
        let handler = _.Notification_Alert;

        if (notification.code == App_Models_Notification.GENERIC_FLASH) {
            handler = _.Notification_Flash;
        }

        if (notification.code == App_Models_Notification.OUTBID ||
            notification.code == App_Models_Notification.OUTBID_TIE ||
            notification.code == App_Models_Notification.MAX_BID_EXPIRED ||
            notification.code == App_Models_Notification.MAX_BID_TIE) {
            handler = _.Notification_Outbid;
        }

        if (notification.code == App_Models_Notification.BID_DENIED) {
            handler = _.Notification_Bid_Denied;
        }

        if (notification.code == App_Models_Notification.REGISTRATION_REMOVED) {
            handler = _.Notification_Registration_Removed;
        }

        if (notification.code == App_Models_Notification.REGISTRATION_DENIED) {
            handler = _.Notification_Registration_Denied;
        }

        if (notification.code == App_Models_Notification.FINALIZING_PICK_YOUR_ITEMS) {
            handler = _.Notification_Finalizing_Choice;
        }

        if (notification.code == App_Models_Notification.CHOICE_ROUND_COMPLETED_NON_WINNER) {
            handler = _.Notification_Choice_Completed_Non_Winner;
        }

        if (notification.code == App_Models_Notification.CHOICE_ROUND_COMPLETED_YOU_ARE_WINNER) {
            handler = _.Notification_Choice_Completed_Winner;
        }

        // Not used?
        // if (notification.code == App_Models_Notification.ITEM_SOLD_YOU_ARE_WINNER) {
        //     handler = _.Notification_Item_Winner;
        // }

        if (notification.code == App_Models_Notification.OUTBID_ENTERPRISE_WF) {
            handler = _.Notification_Low_Bid_Wf;
        }

        if (notification.code == App_Models_Notification.OUTBID_ENTERPRISE_INDIVIDUAL) {
            handler = _.Notification_Low_Bid_Individual;
        }

        if (notification.code == App_Models_Notification.STANDARD_COMPLETED_NON_WINNER) {
            handler = _.Notification_Standard_Completed_Non_Winner;
        }

        if (notification.code == App_Models_Notification.STANDARD_COMPLETED_YOU_ARE_WINNER) {
            handler = _.Notification_Standard_Completed_Winner;
        }

        if (notification.code == App_Models_Notification.AUCTION_COMPLETED_LOSER_POPUP) {
            handler = _.Notification_Auction_Completed_Loser;
        }

        if (notification.code == App_Models_Notification.AUCTION_COMPLETED_WINNER_POPUP) {
            handler = _.Notification_Auction_Completed_Winner;
        }

        return handler;
    }

    // TODO: PAUSE NOTIFICATIONS WHILE NON NOTIFICATION MODALS ARE OPEN

    static async init() {
        _.on_websocket_receive(function (topic, data) {
            // New style notifications.  The websocket data doesn't have any actual notification data, it only signals a possible new notification
            // was delivered.  We have to check an api endpoint to get the notifications.

            if (topic == "registrant_notification") {
                console.warn("Received ws data ", topic, data);

                if (data.force_notification_id) {
                    _.Lib_Notifications.force_flash_notification(data.force_notification_id);
                } else {
                    _.Lib_Notifications.registrant_notification_handler();
                }
            };

            if (topic == "auction_broadcast_flash_message" || topic == "auction_broadcast_generic") {
                console.warn(data);

                if (data.auction_id && (_.AuctionUI && _.AuctionUI.auction_id() != data.auction_id)) {
                    return;
                }

                if (data.auction_round_id && (!_.ac_state || _.ac_state.current_round_id != data.auction_round_id)) {
                    return;
                }

                if (data.do_not_show_registered_users && _.Lib_Auction_Bids.user_registration_approved()) {
                    return;
                }

                let message_type = data.message_type ? data.message_type : 'success';

                if (topic == "auction_broadcast_flash_message") {

                    // Only deliver double messages once within 5 second window.
                    const now = new Date().getTime();
                    if (last_flash_message !== data.message || now - last_flash_message_time >= 5000) {
                        _.flash_alert(data.message, message_type);
                        last_flash_message = data.message;
                        last_flash_message_time = now;
                    }

                } else if (topic == "auction_broadcast_generic") {

                    // Simple handler for other types of events.  Right now only one:

                    // Show popup that auction was completed.
                    if (data.event == "auction_completed_popup") {
                        _.AuctionUI_Auction_General_UI.show_the_entire_auction_was_completed_modal();
                    }
                }
            };

        });

        // Check for notifications when session is updated.
        _.AuctionUI_Session.session_updated_handler(function (data) {
            _.Lib_Notifications.registrant_notification_handler();
        });

        // Check for notifications when websocket is restored.
        _.on_websocket_connected(function () {
            _.Lib_Notifications.registrant_notification_handler();
        });

        // When a modal closes, check for notifications.
        // This is because we are ignoring notifications while any modal dialog is open.
        _.Modal.register_callback_on_all_hide_operations(async function () {
            await _.sleep(500);
            _.Lib_Notifications.registrant_notification_handler();
        });
    }

    static async session_updated_handler() {
        // Auction broadcasts. This registrant's notifications reach the socket that sent the signed
        // registrant token (registrant_auth, wp_lib/session.js).
        _.websocket_send_subscribe("web_notify_subscribe", { auction_id: _.ac_state.auction.id });
    }

    // Called on login, on page load, and automatically when a new notification comes in.
    // DONT AWAIT THIS FUNCTION.  IT COULD LOCK UP THE UI.
    static async registrant_notification_handler() {
        // await _.mutex('registrant_notification_handler', async function () {
        if (!_.Lib_Notifications._registrant_notification_handler) {
            _.Lib_Notifications._registrant_notification_handler = _.debounce(0, async function () {

                let registrant = await _.AuctionUI_Session.get_registrant()

                if (!registrant) {
                    return;
                }

                if (!_.AuctionUI_Session._session_is_loaded) {
                    return;
                }

                let current_round = null;
                if (_.AuctionUI && _.AuctionUI.get_current_round) {
                    current_round = await _.AuctionUI.get_current_round();
                }

                await _.sleep(200);

                // Continuing on...

                let notification_id = null;
                let notification = null;

                try {
                    notification_id = await _.backend_ajax('notifications', 'get', { auction_id: _.ac_state && _.ac_state.auction && _.ac_state.auction.id ? _.ac_state.auction.id : null });
                } catch (e) {
                    console.error(e);
                    return;
                }

                if (!notification_id) {
                    // No notification to display
                    return;
                }

                notification = await App_Models_Notification.get_private(notification_id);

                if (notification && notification.id) {
                    if (current_notification && current_notification.id == notification.id) {
                        return;
                    }

                    if (shown_notification_ids_cache.indexOf(notification.id) != -1) {
                        if (!notification.accepted) {
                            // await _.Lib_Notifications.dismiss_notification(notification.id);
                        }
                        setTimeout(_.Lib_Notifications.registrant_notification_handler, 0);
                        return;
                    }

                    await _.sleep(200);

                    // Did it get updated?
                    if (notification.accepted) {
                        setTimeout(_.Lib_Notifications.registrant_notification_handler, 0);
                        return;
                    }

                    // Do not show notifications while a modal is open.
                    if ($(".lp-modal:visible").length) {
                        return;
                    }

                    let handler = _.Lib_Notifications._map_notification_to_handler(notification);

                    // Setting notification handler class here has the effect that closing the notification closes the open modal.
                    // We assume at this point the open modal, if any, is a notification, and not something like user bid.
                    current_notification_handler_class = new handler(notification);

                    // Did the notification get marked accepted on the server?
                    if (notification.accepted) {
                        // If so dismiss it.

                        if (current_notification_handler_class.$modal) {
                            if (current_notification_handler_class.$modal().is(":visible")) {
                                await _.Modal.close_unhidable();
                            }
                        } else {
                            console.warn("All notifications should have a $modal() method.");
                            await _.Modal.close_unhidable();
                        }

                        current_notification_handler_class = null;

                        await _.Lib_Notifications.dismiss_notification(notification.id, false);

                        // And get the next notification.
                        setTimeout(_.Lib_Notifications.registrant_notification_handler, 0);
                        return;
                    }

                    current_notification = notification;
                    current_notification_subscription = await notification.subscribe(true, _.Lib_Notifications.handle_notification_update);

                    current_notification_handler_class.on_show();

                    // Wait another fraction of a second
                    await _.sleep(200);
                }
            });
        }

        await _.Lib_Notifications._registrant_notification_handler();
        // });
    }

    // Try to load this notification directly.  If it is a flash style notification, display it, and mark it accepted.
    // If the user's browser isn't open at the time the notification is issued via websocket, then the user will get
    // the notification on the next page load via registrant_notification_handler().
    static async force_flash_notification(notification_id) {
        await _.mutex('registrant_notification_handler', async function () {
            let notification = await App_Models_Notification.get(notification_id);

            if (!notification) {
                return;
            }

            // If auction_id is on the notification, only show it if the appropriate auction is visible
            if (notification.auction_id && (!_.AuctionUI || notification.auction_id != _.AuctionUI.auction_id())) {
                return;
            }

            if (shown_notification_ids_cache.indexOf(notification.id) != -1) {
                if (!notification.accepted) {
                    await _.Lib_Notifications.dismiss_notification(notification.id);
                }
                setTimeout(_.Lib_Notifications.registrant_notification_handler, 0);
                return;
            }

            shown_notification_ids_cache.push(notification.id);

            if (notification.code == App_Models_Notification.GENERIC_FLASH) {
                let handler = new _.Notification_Flash(notification);
                handler.on_show();
            }

        });
    }

    static get_current_notification_id() {
        return current_notification ? current_notification.id : null;
    }

    static async handle_current_notification_close(target_notification_id = null, tell_server = true) {
        await _.mutex('handle_current_notification_close', async function () {
            if (!current_notification) {
                console.warn(current_notification);
                return;
            }

            console.log("handle_current_notification_close");

            // Close the notification via handler class
            if (current_notification_handler_class) {
                // Prevent a race condition - if notification changes while the hide function is being called, then do nothing.
                let current_notification_id = current_notification.id;

                if (current_notification_handler_class.$modal) {
                    if (current_notification_handler_class.$modal().is(":visible")) {
                        await _.Modal.close_unhidable();
                    }
                } else {
                    console.warn("All notifications should have a $modal() method.");
                    await _.Modal.close_unhidable();
                }

                if (!current_notification || current_notification.id != current_notification_id) {
                    console.warning("Bailed out of close notification logic - not an issue");
                    return;
                }

                await current_notification_handler_class.on_hide();
            }

            // Unsubscribe from updates for this notification.
            try {
                await current_notification_subscription.unsubscribe();
            } catch (e) {
                // Noop
            }

            let notification_id = current_notification.id * 1; // Clone value, source value will be cleared next

            // Clear variables related to this notification.
            current_notification = null;
            current_notification_subscription = null;

            if (target_notification_id === null || target_notification_id == notification_id) {
                shown_notification_ids_cache.push(notification_id);

                if (tell_server) {
                    try {
                        await _.backend_ajax('notifications', 'dismiss', { notification_id: notification_id });
                    } catch (e) {
                        console.error(e);
                        return;
                    }
                }
            } else {
                console.warn("Tried to close the wrong notification ", notification_id);
            }

            // Check for any new notifications.
            setTimeout(_.Lib_Notifications.registrant_notification_handler, 0);
        });
    }

    static async dismiss_notification(notification_id, send_update_to_server = true) {
        if (current_notification && current_notification.id == notification_id) {
            _.Lib_Notifications.handle_current_notification_close(notification_id, send_update_to_server);
        } else {
            if (send_update_to_server) {
                try {
                    await _.backend_ajax('notifications', 'dismiss', { notification_id: notification_id });
                } catch (e) {
                    return;
                }
            }
        }
    }

    static async handle_notification_update() {
        await _.mutex('handle_notification_update', async function () {
            if (!current_notification) {
                return;
            }

            let _the_current_notification_id = current_notification.id;

            // Did the notification get set to accepted via the server or otherwise?
            if (current_notification.accepted) {
                // If so, dismiss it.
                _.Lib_Notifications.dismiss_notification(_the_current_notification_id, false);
                return;
            }

            if (current_notification.id != _the_current_notification_id) {
                return;
            }

            await current_notification_handler_class.on_update();
        })
    }
}
